import Products from './Products';
import Features from './Features';
import Requirements from './Requirements';
import Subtasks from './Subtasks';
import JiraProjects from './JiraProjects';
import JiraIssues from './JiraIssues';
import { useGeneratorContext } from '@Context/GeneratorContext';
const Generate = () => {
  const { isJiraMode, setJiraMode } = useGeneratorContext();

  return (
    <div data-testid="test-generate" className="flex h-full">
      <div className="flex w-full flex-col gap-2 lg:flex-row">
        {/* BOX 1 */}
        <div
          data-testid="test-generator-box-1"
          className="flex h-full w-full flex-col gap-2 lg:w-2/5"
        >
          {isJiraMode ? (
            <>
              <JiraProjects
                showPromptCrud={true}
                onModeSwitch={() => setJiraMode(false)}
              />
              <JiraIssues />
            </>
          ) : (
            <>
              <Products
                showPromptCrud={true}
                onModeSwitch={() => setJiraMode(true)}
              />
              <Features />
            </>
          )}
        </div>

        {/* BOX 2 */}
        <div
          data-testid="test-generator-box-2"
          className="flex h-full w-full flex-col gap-2 lg:w-3/5"
        >
          {isJiraMode ? <Subtasks /> : <Requirements />}
        </div>
      </div>
    </div>
  );
};

export default Generate;
